import { createUseStyles } from 'react-jss';

const styles = {
  content: {
    paddingBottom: '5rem',
    maxWidth: '170rem',
    margin: '0 auto',
  },
  emailsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2rem',
    padding: 0,
    margin: 0,
    listStyle: 'none',
  },
  wrapper: {
    position: 'relative',
    minHeight: '20rem',
  },
  infoTitle: {
    margin: '0 0 2rem',
    fontSize: '1.6rem',
    textAlign: 'right',
  },
  totalAmount: {
    margin: '0 0.5rem',
  },
  saveSettingsButton: {
    margin: '5rem auto 8rem',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
